module.exports = __webpack_public_path__ + "img/实时预警.89b24ae6.png";